import { computed, defineComponent, PropType } from "vue";
import FormInfo from "./FormInfo";
import Utils from "../utils/Utils";
import Breadcrumb from "./Breadcrumb";
import OfferUtils, { OfferTariff } from "../utils/OfferUtils";
import SmeUtils from "../utils/SmeUtils";
import { BaseOrderJson } from "../OrderForm";

export default defineComponent({
    components: {
        FormInfo,
        Breadcrumb,
    },

    template: `
        <div ref="widget" v-if="options.offer" class="SummaryBox" :class="{ 'SummaryBox--opened': opened }">
            <div class="SummaryBox__inner">
                <Breadcrumb v-if="step" :step="step" :sme="options.sme" />

                <div class="SummaryBox__offer">
                    <span>Wybierasz:</span>
                    <div class="SummaryBox__offer-title">{{ options.offer.title }}</div>
                </div>

                <div class="SummaryBox__details">
                    <button class="SummaryBox__show SummaryBox__show2" type="button" @click="opened = !opened">
                        <div>
                            <span>Wybierasz: <b>{{ options.offer.title }}</b></span>

                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                                <path d="M1 1L6 6L11 1" stroke="#005537" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </button>

                    <button type="button" class="SummaryBox__change button button--secondary" @click="$emit('offer:change')">Zmień</button>

                    <FormInfo title="Okres obowiązywania" :value="pricewarrantytitle" />
                    <FormInfo v-if="!options.sme" title="Taryfa" :value="tariff" />
                    <FormInfo v-if="options.offer?.cashback" title="Bonus na start" :value="priceCashback" />

                    <template v-if="options.sme">
                        <template v-if="options.offer?.prices.length == 1">
                            <FormInfo title="Cena za kWh" :value="priceOfferSme" />
                        </template>

                        <template v-if="options.offer?.prices.length == 2">
                            <FormInfo v-if="options.tariff == 'C12a'" title="Cena za kWh w szczycie" :value="priceOfferSme" />
                            <FormInfo v-if="options.tariff == 'C12a'" title="Cena za kWh poza szczytem" :value="priceOfferSme2" />
                            <FormInfo v-if="options.tariff == 'C12b'" title="Cena za kWh dzienna" :value="priceOfferSme" />
                            <FormInfo v-if="options.tariff == 'C12b'" title="Cena za kWh nocna" :value="priceOfferSme2" />
                        </template>
                    </template>

                    <template v-if="!options.sme">
                        <template v-if="options.offer?.prices.length == 1">
                            <FormInfo title="Cena za kWh" :value="priceOffer1" />
                        </template>

                        <template v-if="options.offer?.prices.length == 2">
                            <FormInfo title="Strefa dzienna" :value="priceOffer1" />
                            <FormInfo title="Strefa nocna i weekendowa" :value="priceOffer2" />
                        </template>
                    </template>

                    <FormInfo v-if="visible_usage" title="Deklarowane zużycie" :value="usage" />
                    <FormInfo v-if="options.sme" title="Termin płatności" :value="due_days" />
                    <FormInfo v-if="!options.sme" title="Długość umowy" :value="period" />
                    <FormInfo v-if="!options.sme" title="Okres wypowiedzenia" :value="noticeperiod" />
                </div>

                <button class="SummaryBox__show SummaryBox__show1" type="button" @click="opened = true">
                    <div>
                        <span>Wybierasz: <b>{{ options.offer.title }}</b></span>

                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                            <path d="M1 1L6 6L11 1" stroke="#005537" stroke-linecap="round"/>
                        </svg>
                    </div>
                </button>
            </div>

        </div>
    `,

    emits: [
        'offer:change',
    ],

    props: {
        options: { type: Object as PropType<BaseOrderJson>, required: true },

        step: { type: Number },

        visible_usage: { type: Boolean, default: true },
    },

    computed: {
        tariff() {
            return this.options.tariff ? this.options.tariff + ' ' + OfferUtils.getTariffType(this.options.tariff) : null;
        },

        priceOfferSme() {
            return Utils.priceFormat(this.options.offer.prices[0].price_netto, false, ' zł', 3);
        },

        priceOfferSme2() {
            return Utils.priceFormat(this.options.offer.prices[1].price_netto, false, ' zł', 3);
        },

        priceOffer1() {
            return Utils.priceFormat(this.options.offer.prices[0].price, false, ' zł', 3);
        },

        priceOffer2() {
            return Utils.priceFormat(this.options.offer.prices[1].price, false, ' zł', 3);
        },

        priceCashback() {
            return Utils.priceFormat(this.options.offer?.cashback, true, ' zł');
        },

        pricewarrantytitle() {
            return this.options.offer?.price_warranty ? Utils.yearsTitle(this.options.offer?.price_warranty) : null;
        },

        usage() {
            return this.options.usage + ' kWh / rok';
        },

        periodo() {
            return this.options.offer?.period ? Utils.yearsTitle(this.options.offer?.period) : 'bezterminowo';
        },

        period() {
            return this.options.offer?.period ? Utils.yearsTitle(this.options.offer?.period) : 'Czas nieoznaczony';
        },

        noticeperiod() {
            return Utils.monthsTitle(this.options.noticeperiod ?? 1);
        },
    },

    data() {
        return {
            opened: false,
        };
    },

    mounted() {
        $(document).on('click', (e) => {
            const el = this.$refs.widget;

            if (el && !(el === e.target || el.contains(e.target))) {
                this.opened = false;
            }
        });
    },

    setup(props, ctx) {
        const due_days = computed(() => {
            return SmeUtils.getDueDays(props.options.offer) + ' dni';
        });

        return {
            due_days,
        };
    },
});
